import clsx from 'clsx';
import { FunctionComponent } from 'react';
import styles from './PaymentMethod.module.css';
import {
    faArrowRotateLeft,
    faHandHoldingDollar,
    faMoneyBill1,
    faWallet,
    IconDefinition
} from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCreditCard } from '@fortawesome/pro-regular-svg-icons';

interface PaymentMethodProps {
    paymentMethodId: string;
    paymentMethodName: string;
    cardDigits: string | null;
    isRefund?: boolean;
    className?: string;
}

const visa = 'visa';
const mastercard = 'mc';
const amex = 'amex';
const cash = 'cash';
const other = 'other';
const path = '/images/creditCards/';

const iconsCard: Map<string, string> = new Map([
    [visa, path.concat('icon-visa.svg')],
    [mastercard, path.concat('icon-mastercard.svg')],
    [amex, path.concat('icon-amex.svg')]
]);

const getIcon = (paymentMethodId: string): IconDefinition => {
    const icons: { [key: string]: IconDefinition } = {
        cash: faMoneyBill1,
        other: faHandHoldingDollar,
        wallet: faWallet,
        amex: faCreditCard,
        mc: faCreditCard,
        visa: faCreditCard
    };

    return icons[paymentMethodId] || faHandHoldingDollar;
};

export const PaymentMethod: FunctionComponent<PaymentMethodProps> = props => (
    <div className={clsx(styles.container, props.className)}>
        <FontAwesomeIcon
            icon={props.isRefund ? faArrowRotateLeft : getIcon(props.paymentMethodId)}
            className={styles.icon}
        />
        <p className={styles.paymentMethodName}>{props.isRefund ? 'Refund' : props.paymentMethodName}</p>
        {props.cardDigits && <p className={styles.dot}>·</p>}
        {props.cardDigits && (
            <img
                src={iconsCard.get(props.paymentMethodId) ?? path.concat('icon-visa.svg')}
                className={styles.iconCard}
            />
        )}
        <p className={styles.paymentMethodName}>{props.cardDigits}</p>
    </div>
);

export default PaymentMethod;
